module.exports = __webpack_public_path__ + "img/icon-acc-manage.f2032884.png";